module.exports = __webpack_public_path__ + "d1bc6f53.pdf";


//////////////////
// WEBPACK FOOTER
// ./public/docs/BitaaGuide.pdf
// module id = 1330
// module chunks = 12